import { createApi } from '@reduxjs/toolkit/query/react'
import { customClientBaseQuery } from './customElxFetchBase'

export const dealerTypeApi = createApi({
  reducerPath: 'dealerTypeApi',
  baseQuery: customClientBaseQuery,
  tagTypes: ['DealerType'],
  endpoints: (builder) => ({
    getDealerTypeList: builder.query({
      query() {
        return {
          url: 'dealerType/all',
          method: 'GET',
          credentials: 'include',
        }
      },
      transformResponse: (result: any) => result.data,
      providesTags: ['DealerType'],
    }),

    createDealerType: builder.mutation({
      query(data) {
        return {
          url: 'dealerType/create',
          method: 'POST',
          body: data,
          credentials: 'include',
        }
      },
      invalidatesTags: ['DealerType'],
    }),

    updateDealerTypeDetails: builder.mutation({
      query(data) {
        return {
          url: 'dealerType/update',
          method: 'POST',
          body: data,
          credentials: 'include',
        }
      },
      invalidatesTags: ['DealerType'],
    }),

    updateDealerTypeStatus: builder.mutation({
      query(data) {
        return {
          url: 'dealerType/update-status',
          method: 'POST',
          body: data,
          credentials: 'include',
        }
      },
      invalidatesTags: ['DealerType'],
    }),
  }),
})

export const {
  useGetDealerTypeListQuery,
  useCreateDealerTypeMutation,
  useUpdateDealerTypeDetailsMutation,
  useUpdateDealerTypeStatusMutation,
} = dealerTypeApi
